import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { IoMdClose } from 'react-icons/io';
import { BiError } from 'react-icons/bi';
import { BsClock } from 'react-icons/bs';
import { IoMdCheckmark } from 'react-icons/io'
import './TransactionStatus.css';

function TransactionStatus(props) {
  if(props.transactionStatus === "Mobile failed") {
    return (
      <div className = "videoMintDetails-transactionUnsuccessfulStatus">
        <div className = "videoMintDetails-transactionUnsuccessfulStatusIconContainer">
          <BiError className = "videoMintDetails-transactionStatusUnsucessfullIcon" />
        </div>
        <div className="videoMintDetails-TransactionStatusText">
          You can only transact on desktop 😢
        </div>
      </div>
    );
  } else if(props.transactionStatus === "Failed") {
    return (
      <div className = "videoMintDetails-transactionUnsuccessfulStatus">
        <div className = "videoMintDetails-transactionUnsuccessfulStatusIconContainer">
          <BiError className = "videoMintDetails-transactionStatusUnsucessfullIcon" />
        </div>
        <div className="videoMintDetails-TransactionStatusText">
          Minting was unsuccessful 😢
        </div>
      </div>
    );
  } else if(props.transactionStatus === "Pending") {
    return (
      <div className = "videoMintDetails-transactionPendingStatus">
        <div className = "videoMintDetails-transactionPendingStatusIconContainer">
          <BsClock className = "videoMintDetails-transactionStatusPendingIcon" />
        </div>
        <div className="videoMintDetails-TransactionStatusText">
          Transaction is pending 🕥
        </div>
        <svg role="status" class="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
      </div>
    );
  } else if(props.transactionStatus === "Mint Complete") {
    return (
      <div className = "videoMintDetails-transactionSuccessful">
        <div className = "videoMintDetails-transactionApproveStatusIconContainer">
          <IoMdCheckmark className = "videoMintDetails-transactionStatusApproveIcon" />
        </div>
        <div>
          <div className="videoMintDetails-TransactionStatusText">
            Your Transaction was Successful! ✨
          </div>
          <div className="text-zinc-400 text-xs">
            You are now an owner of {props.item.name.replaceAll("_", " ")}.
          </div>
        </div>
      </div>
    );
  } else if(props.transactionStatus === "Burn Complete") {
    return (
      <div className = "videoMintDetails-transactionSuccessful">
        <div className = "videoMintDetails-transactionApproveStatusIconContainer">
          <IoMdCheckmark className = "videoMintDetails-transactionStatusApproveIcon" />
        </div>
        <div>
          <div className="videoMintDetails-TransactionStatusText">
            Your Transaction was Successful!
          </div>
          <div className="text-zinc-400 text-xs">
            You burned {props.item.name.replaceAll("_", " ")}.
          </div>
        </div>
      </div>
    );
  } else if(props.transactionStatus.includes("Complete")) {
    let successMessage;
    if(props.transactionStatus === "List Complete") {
      successMessage = "You successfully listed this item!";
    } else if(props.transactionStatus === "Delist Complete") {
      successMessage = "You successfully delisted this item!";
    } else if(props.transactionStatus === "Price Update Complete") {
      successMessage = "You successfully updated the price of this item!";
    } else if(props.transactionStatus === "Purchase Complete") {
      successMessage = "Your pucrhase was successful, you are now an owner of this item.";
    } else if(props.transactionStatus === "Start Auction Complete") {
      successMessage = "You successfully started an auction";
    } else if(props.transactionStatus === "Create Bid Complete") {
      successMessage = "You successfully placed a bid";
    } else if(props.transactionStatus === "Settle Auction Complete") {
      successMessage = "You successfully settled an auction";
    } else if(props.transactionStatus === "Payment Complete") {
      successMessage = "You successfully completed the payment";
    } else if(props.transactionStatus === "Claim Complete") {
      successMessage = "You successfully claimed the POAP";
    }
    return (
      <div className = "videoMintDetails-transactionSuccessful">
        <div className = "videoMintDetails-transactionApproveStatusIconContainer">
        <IoMdCheckmark className = "videoMintDetails-transactionStatusApproveIcon" />
        </div>
      <div>
        <div className="videoMintDetails-TransactionStatusText">
          Your Transaction was Successful! ✨
        </div>
        <div className="text-zinc-400 text-xs">
          {successMessage}
        </div>
        </div>
      </div>
    );
  }
  return null;
}

export default TransactionStatus;
